import { render, staticRenderFns } from "./groupCard.vue?vue&type=template&id=0d2285d7&scoped=true"
import script from "./groupCard.vue?vue&type=script&lang=js"
export * from "./groupCard.vue?vue&type=script&lang=js"
import style0 from "./groupCard.vue?vue&type=style&index=0&id=0d2285d7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2285d7",
  null
  
)

export default component.exports